import { PureComponent } from 'react';

import { Button } from '@ipfabric/ui-components/Button/Button';
import get from 'lodash/get';
import handleEvent from 'utils/handleEvent';

// type PropsType = {
//   msg: Object,
//   onShowWarning: Function,
//   onUploadSnapshot: Function,
//   hasWritePermission: boolean,
// };

export default class UploadDialogue extends PureComponent {
  handleUploadClick = handleEvent((e) => {
    e.preventDefault();
    this.fileUpload.click();
  });

  getRef = (c) => {
    this.fileUpload = c;
  };

  handleUploadChange = handleEvent(() => {
    const { onUploadSnapshot, onShowWarning, msg } = this.props;
    const file = this.fileUpload.files[0];
    if (!file) {
      return;
    }
    if (!/\.(tar|tgz|tar.gz)$/.test(file.name)) {
      onShowWarning({ message: get(msg, 'upload.wrongExtension') });
      return;
    }
    onUploadSnapshot({
      file,
    });
    this.fileUpload.value = '';
  });

  render() {
    const { msg, uploading, hasWritePermission } = this.props;
    return (
      <div className='flex'>
        <input
          type='file'
          className='snapshots-upload-hidden'
          id='snapshots-upload-hidden'
          accept='.tar,.tgz,.tar.gz'
          ref={this.getRef}
          onChange={this.handleUploadChange}
        />
        <Button
          size='default'
          variant='outline'
          className='grow'
          onClick={this.handleUploadClick}
          disabled={!hasWritePermission}
          loading={uploading}
        >
          {get(msg, 'upload.btnUpload')}
        </Button>
      </div>
    );
  }
}
